<template>
  <div
    id="carouselExampleSlidesOnly"
    class="carousel slide"
    data-ride="carousel"
    data-interval="5000"
    data-pause="true"
  >
    <ol class="carousel-indicators">
      <li
        data-target="#carouselExampleIndicators"
        :data-slide-to="i"
        :class="{ active: slider.active }"
        v-for="(slider, i) in sliders"
        :key="i"
      ></li>
    </ol>
    <div class="carousel-inner">
      <div
        class="carousel-item"
        :class="{ active: slider.active }"
        v-for="(slider, i) in sliders"
        :key="i"
      >
        <img :src="slider.path" class="d-block w-100" :alt="`slider-${i}`" />
        <div class="carousel-caption" v-if="slider.caption">
          <p class="heading">{{ slider.caption.heading }}</p>
          <h5 v-if="slider.caption.text">{{ slider.caption.text }}</h5>
          <button
            @click="goto(slider.btn.link)"
            class="heading btn btn-outline-light btn-lg"
            v-if="slider.btn"
            >{{ slider.btn.text }}</button
          >
        </div>
      </div>
    </div>
    
  </div>
</template>

<style scope>
.heading {
  color: #cacaca;
}
.carousel-caption {
  top: 25%;
  bottom: 20%;
}
.carousel-caption h5 {
  font-family: Bellefair;
  font-size: 3.5em;
  font-weight: bold;
}
.carousel-caption .btn {
  margin-top: 30px;
  padding: 20px 25px;
  border-radius: 0px;
}
@media only screen and (max-width: 600px) {
  .carousel-caption h5 {
    font-size: 20px;
  }
  .carousel-caption {
    top: 0%;
  }
  .carousel-caption .btn {
    margin-top: 0px;
    padding: 8px 25px;
    border-radius: 0px;
    font-size: 10px;
  }
}
</style>

<script>
export default {
  mounted() {
    console.log("Carrousel mounted")
  },
  methods: {
    goto(link) {
      if(link.startsWith("http")) {
        window.open(link, "_blank")
      } else {
        this.$router.push(link)
      }
    }
  },
  data() {
    return {
      sliders: [
        //  {
        //   path: "../slider/home-4.jpg",
        //   caption: {
        //     heading: "EIEN SUSHI",
        //     text: "2023",
        //   },
        //   active: true,
        //   btn: { text: "VER MENU", link: "/menu" },
        // },
        {
          path: "../slider/2025/IMG_4150.webp",
          caption: { heading: "", text: "" },
          //btn: { text: "VER CARTA", link: "#" },
          active: true
        },
        {
          path: "../slider/2025/IMG_4144.webp",
          //active: true,
          caption: { heading: "", text: "" },
          //btn: { text: "VER CARTA", link: "#" },
        },
        {
          path: "../slider/2025/IMG_4134.webp",
          caption: { heading: "", text: "" },
          //btn: { text: "VER CARTA", link: "#" },
        },
        {
          path: "../slider/2025/IMG_4143.webp",
          caption: { heading: "", text: "" },
          //btn: { text: "VER CARTA", link: "#" },
        },
        {
          path: "../slider/2025/IMG_4146.webp",
          caption: { heading: "", text: "" },
          //btn: { text: "VER CARTA", link: "#" },
        },
        
        // {
        //   path: "../slider/home-2.jpg",
        //   caption: { heading: "", text: "PARA LLEVAR" },
        //   btn: { text: "VER MENU", link: "/menu" },
        // },
      ],
    };
  },
};
</script>